import log from 'salvo-lite/log'

class Exponea {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true, subtree: true }

        // Callback function to execute when mutations are observed
        var callback = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.target.classList.contains('exponea-animate')) {
                    this._theme.registerComponents(this._elem)
                }
            }
        }

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback)

        // Start observing the target node for configured mutations
        observer.observe(this._elem, config)

        // Later, you can stop observing
        // observer.disconnect()
    }
}

export default Exponea



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Exponea.js